// extracted by mini-css-extract-plugin
module.exports = {"containerSidebar":"style_containerSidebar__lI8aO"};